module.exports = __webpack_public_path__ + "static/tranquility-logo-de6e1d3210cc1502fac3df1c996ce7c2.png";